<template>
  <div
    class="image-not-found w-100 d-block d-flex align-items-center height-80 p-1 bg-light rounded justify-content-center"
  >
    <div class="text-center">
      <div class="p-1">
        <FeatherIcon
          icon="ImageIcon"
          size="24"
          class="text-muted"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageNotFound',
  props: {
    widthSize: {
      type: String,
      default: 'w-100',
    },
    heightSize: {
      type: String,
      default: 'height-100',
    },
  },
}
</script>

<style scoped>
.image-not-found {
  border: 1px solid #dddddd;
}
</style>
